import { Badge } from '@frontend/design_system'
import { ApprovalInfoBadgesProps } from './types'
import styles from './styles.module.scss'
import { APPROVAL_INFO_BADGES } from 'texts/pendingForApproval'

export const ApprovalInfoBadges = ({
  isRequested = false,
}: ApprovalInfoBadgesProps) => (
  <div className={styles.badges} data-testid="approval-info-badges">
    <Badge
      message={APPROVAL_INFO_BADGES.SUBMIT}
      color="yellow800"
      typographyName="body1WMedium"
      type="warning"
      dataTestId="submit-info-badge"
    />
    {isRequested && (
      <Badge
        message={APPROVAL_INFO_BADGES.REQUESTED}
        color="red600Master"
        typographyName="body1WMedium"
        dataTestId="requested-info-badge"
      />
    )}
  </div>
)
